import { render, staticRenderFns } from "./SalesManagerVacations.vue?vue&type=template&id=70c74c2e&"
import script from "./SalesManagerVacations.vue?vue&type=script&lang=js&"
export * from "./SalesManagerVacations.vue?vue&type=script&lang=js&"
import style0 from "./SalesManagerVacations.vue?vue&type=style&index=0&id=70c74c2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports